
const copy = require('copy-text-to-clipboard');

document.addEventListener('click', event => {

    let el = event.target.closest('[data-copy]');
    if (! el) return;

    event.preventDefault();
    let text = el.dataset.copy;
    copy(text);
    Notify.info(`Zkopírováno: ${text}`);

}, false);
